export const imageBasePath = "/app/assets/";
// export const imageBasePath = "/app-testing/assets/";
export const basename = "/purchase_testing";
// export const imageBasePath = "/gift/assets/";

export const REACT_APP_API_END_POINT = "";

